import { render, staticRenderFns } from "./Customers.html?vue&type=template&id=57394ae8&external"
import script from "./Customers.js?vue&type=script&lang=js&external"
export * from "./Customers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports